import { createFeatureContext } from 'src/libs/FeatureConfig';

export const { FeatureConfigProvider, useFeatureConfig } = createFeatureContext(
  [
    {
      name: 'verified-id',
      gradualRolloutConfig: {
        'employer-seek-au': ['5'],
        'employer-seek-hk': ['1'],
        'employer-seek-id': ['1'],
        'employer-seek-my': ['1'],
        'employer-seek-nz': ['1'],
        'employer-seek-ph': ['1'],
        'employer-seek-sg': ['1'],
        'employer-seek-th': ['1'],
      },
    },
  ],
);
